
interface Props {
  code?: string;
  maximumFractionDigits?: number;
  symbol?: string;
}

const useCurrencyText = (): ((amount: number, props?: Props) => string) => {
  return (
    amount: number,
    { code = 'USD', maximumFractionDigits = 2, symbol }: Props = {}
  ) => {
    // Hack for replacing $ symbol to custom symbol
    if (symbol) {
      code = 'USD';
    }
    let currencyText = new Intl.NumberFormat('ru', {
      style: 'currency',
      currency: code,
      maximumFractionDigits,
      minimumFractionDigits: 0,
    }).format(amount);
    if (symbol) {
      currencyText = currencyText.replace('$', symbol);
    }

    return currencyText;
  };
};

export default useCurrencyText;
